module.exports = __webpack_public_path__ + "res/35-img_game_media.c0649d5888310853e777160ab5277ded.png";